import React, { FC, useEffect, useRef } from 'react';
import { t } from '../../../../utils/helpers';
import send from '../../../../assets/images/paper_plane.svg';
import { EmojiPicker } from '../../emojiPicker/emojiPicker';

type PropsType = {
  myMessage: string;
  setMyMessage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sendMessage: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    pid: number
  ) => void;
  recipientId: number | undefined;
  handleEmoji: (emoji: string) => void;
};

export const PrivateChatFooter: FC<PropsType> = ({
  myMessage,
  setMyMessage,
  sendMessage,
  recipientId,
  handleEmoji,
}: PropsType) => {
  const inputRef = useRef<HTMLInputElement>(null);

  function handle(e: any) {
    e.stopPropagation();
    e.preventDefault();
    if (!recipientId) return;
    sendMessage(e, recipientId);
  }

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <footer className="lobby-chat__footer">
      <form className="messages-form" action="" onSubmit={(e) => handle(e)}>
        <div className="messages-form__send-area">
          <input
            ref={inputRef}
            className="messages-form__input"
            type="text"
            placeholder={`${t('input_text_here')}...`}
            value={myMessage}
            onChange={setMyMessage}
          />
        </div>
        <div className="messages-form__emoji">
          {/* <EmojiPicker handleEmoji={handleEmoji} /> */}
        </div>
        <div className="messages-form__send">
          {(recipientId || recipientId === 0) && (
            <button className="messages-form__button-send">
              <img src={send} alt="button send" />
            </button>
          )}
        </div>
      </form>
    </footer>
  );
};
